module.exports = __webpack_public_path__ + "img/cww_13.4ad79151.jpg";